export const Gallery = (props) => {
  return (
    <div id='portfolio' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Portfolio</h2>
          
        </div>
        <div className='row'>
          <div className='portfolio-items'>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/praying_hab.jpg'
                    title='Praying Hab'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Praying Hab</h4>
                    </div>
                    <img
                      src='img/portfolio/praying_hab.jpg'
                      className='img-responsive gallery-image'
                      alt='Praying Hab'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/ishango-college.png'
                    title='Ishango e-college'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Ishango e-college</h4>
                    </div>
                    <img
                      src='img/portfolio/ishango-college.png'
                      className='img-responsive gallery-image'
                      alt='Ishango e-college'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/medi-fellows.jpg'
                    title='Medifellows'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Medi-Fellows</h4>
                    </div>
                    <img
                      src='img/portfolio/medi-fellows.jpg'
                      className='img-responsive gallery-image'
                      alt='Medifellows'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/job4gulf.jpg'
                    title='Jobs 4 Gulf'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Jobs 4 Gulf</h4>
                    </div>
                    <img
                      src='img/portfolio/job4gulf.jpg'
                      className='img-responsive gallery-image'
                      alt='Jobs 4 Gulf'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/zema_app.jpg'
                    title='de-provence'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Zema Mobile App</h4>
                    </div>
                    <img
                      src='img/portfolio/zema_app.jpg'
                      className='img-responsive gallery-image'
                      alt='de-provence'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/bit-rights.png'
                    title='bit-rights'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Bit Rights</h4>
                    </div>
                    <img
                      src='img/portfolio/bit-rights.png'
                      className='img-responsive gallery-image'
                      alt='bit-rights'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/meri-gift.png'
                    title='Meri Gift'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Meri Gift</h4>
                    </div>
                    <img
                      src='img/portfolio/meri-gift.png'
                      className='img-responsive gallery-image'
                      alt='Meri Gift'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/goldblocks.jpg'
                    title='Gold Blocks'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Gold Blocks</h4>
                    </div>
                    <img
                      src='img/portfolio/goldblocks.jpg'
                      className='img-responsive gallery-image'
                      alt='Gold Blocks'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/volentix_website.png'
                    title='Volentix'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Volentix</h4>
                    </div>
                    <img
                      src='img/portfolio/volentix_website.png'
                      className='img-responsive gallery-image'
                      alt='Volentix'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
